/**
 * This is a simple record class that can establish default values and
 * immutabily update itself.
 */

class Entity {
  static defaults = {
    // NOOP. Default attributes go here
  }

  constructor(...params) {
    this._params = Object.assign({}, this.constructor.defaults, ...params)

    Object.assign(this, this._params)

    this.setup()
  }

  setup() {
    // NOOP
  }

  update(...next) {
    let Record = this.constructor

    return new Record(this._params, ...next)
  }
}

export default Entity



// WEBPACK FOOTER //
// ./src/entities/entity.js